/**
 * Shared client/server utilities used across the codebase.
 */
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

import type { CURRENCIES } from "@/services/stripe/plans.config"

/**
 * Merge Tailwind CSS classes with conflict resolution.
 * Combines `clsx` (conditional classes) with `tailwind-merge` (deduplicates
 * conflicting Tailwind utilities, e.g., `p-2 p-4` → `p-4`).
 *
 * @usedBy Every shadcn/ui component in `app/components/ui/`
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a numeric amount as a localized currency string (no decimals).
 * Always uses `en-US` locale. Currency code comes from the plans config enum.
 */
export const getformattedCurrency = (
  amount: number,
  defaultCurrency: CURRENCIES
) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: defaultCurrency,
    maximumFractionDigits: 0,
  }).format(amount)
}
